<div class="modal-header bg-head py-2">
  <h6 class="modal-title">{{ header }}</h6>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onNo()"
  ></button>
</div>
<div class="modal-body">
  <p>{{ statement }}</p>
</div>
<div class="modal-footer">
  <button
    *ngIf="isOk"
    type="button"
    class=" bl-btn btn btn-sm"
    (click)="onOk()"
  >
    OK
  </button>
  <button
    *ngIf="!isOk"
    type="button"
    class=" bl-btn btn btn-sm"
    (click)="onYes()"
  >
    {{comfirmButton}}
  </button>
  <button
    *ngIf="!isOk"
    type="button"
    class=" btn btn-sm bg-light"
    (click)="onNo()"
  >
    {{cancelButton}}
  </button>
</div>
